import React, { useState, useEffect, useRef } from 'react';
import logo from './images/logo.png';
import Image1 from "./small_images/1.1.jpg"
import Image2 from "./small_images/2.1.jpg"
import Image3 from "./small_images/3.1.jpg"
import Image4 from "./small_images/4.1.jpg"
import Image5 from "./small_images/5.1.jpg"
import Image6 from "./small_images/6.1.jpg"
import Image7 from "./small_images/7.1.jpg"
import Image8 from "./small_images/8.1.jpg"
import Image9 from "./small_images/9.1.jpg"
import Image10 from "./small_images/10.1.jpg"
import Image11 from "./small_images/11.1.jpg"
import Image12 from "./small_images/12.1.jpg"
import Image13 from "./small_images/13.1.jpg"

import Poster1 from "./posters/Poster1.png"
import Poster2 from "./posters/Poster2.png"
import Poster3 from "./posters/Poster3.png"
import Poster4 from "./posters/Poster4.png"
import Poster5 from "./posters/Poster5.png"
import Poster6 from "./posters/Poster6.png"
import Poster7 from "./posters/Poster7.png"
import Poster8 from "./posters/Poster8.png"
import Poster9 from "./posters/Poster9.png" 
import Poster21 from "./posters/Poster2.1.png"
import Poster22 from "./posters/Poster2.2.png"

function Home({ projects = [], btsVideos = [], trailers = [] }) {
    const [showTrailer, setShowTrailer] = useState(null);
    const videoRefs = useRef([]);
    const [promoterLoadedCount, setPromoterLoadedCount] = useState(0);
    const [isPromoterLoading, setIsPromoterLoading] = useState(true);

    const getSeamlessLoop = (items) => {
        if (!items || items.length === 0) return [];
        // Repeat items to ensure we have enough content to fill the screen width
        // Minimum target: 10 items to be safe for wide screens
        let looped = [...items];
        while (looped.length < 5) {
            looped = [...looped, ...items];
        }
        // Return two copies of the "full set" for the 50% scroll logic
        return [...looped, ...looped];   
    };
    // Helper to create a seamless loop of items
    
    // Function to play trailer
    const playTrailer = (trailer) => {
        // Handle both direct URLs (for trailers section) and trailer objects (for project cards)
        const trailerUrl = typeof trailer === 'string' ? trailer : trailer.videoUrl;
        setShowTrailer(trailerUrl);
    };



    const closeTrailer = () => {
        setShowTrailer(null);
    };
    
    // Get first 3 projects for home page display
    const homeProjects = projects.slice(0, 9);

    const trailerPosters = [
        Poster2, Poster3, Poster4, Poster5, Poster6, Poster7, Poster8, Poster9
    ]

    const btsPosters = [
        Poster21, Poster22
    ]
    
    const promoterPortfolio = [
        {
            low: Image1,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/7ced1a09-a1ca-4c7b-ab74-b863c78bdacd-1.png"
        },
        {
            low: Image2,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/8f9ad719-083e-48e5-b4b4-a7e9a4cc17fb-2.png",
        },
        {
            low: Image3,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/7d3b612d-cbfa-4de1-8db8-1de1a6064b58-3.png",
        },
        {
            low: Image4,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/fac1aff7-99fa-4050-bf9c-fa5834daad2e-4.png",
        },
        {
            low: Image5,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/e2426de6-06cf-441e-beea-a94f9e1db65a-5.png",
        },
        {
            low: Image6,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/e462629d-71a7-4c14-870b-f6ecff9c2c34-6.png",
        },
        {
            low: Image7,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/4e77c8b6-1d3a-4b2d-a756-93792edcdcec-7.png",
        },
        {
            low: Image8,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/9cf02f54-a3b3-4351-91c0-17dfeacae72e-8.png",
        },
        {
            low: Image9,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/6d30054b-b585-49ec-9ae5-d7e25b7e1fb0-9.png",
        },
        {
            low: Image10,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/cb9918dc-a52a-44b1-945e-ccd3f4dba02d-10.png",
        },
        {
            low: Image11,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/786d6139-edc7-45ea-b7e7-4eac6ac4099e-11.png",
        },
        {
            low: Image12,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/13ca952b-7fe6-42c7-ad7a-aeac5cfca7e1-12.png",
        },
        {
            low: Image13,
            high: "https://d176ikvqfx9vta.cloudfront.net/promoters/2cc86dc1-b5b2-45f4-8814-641cdde06896-13.png",
        }
    ]

    useEffect(() => {
        if (promoterLoadedCount === promoterPortfolio.length) {
            setIsPromoterLoading(false);
        }
    }, [promoterLoadedCount]);

    const loopedTrailers = getSeamlessLoop(trailers);
    const loopedBts = getSeamlessLoop(btsVideos);
    // Removed aggressive video autoplay effect to improve performance

    return (
        <>
            {/* Hero Section */}
            <section id="home" className="hero">
                <div className="hero-logo">
                    <img src={logo} className="hero-logo-img" alt="VSHOTS Logo" />
                </div>
                <h1 className="hero-heading">STORIES THAT STAY </h1>
                <div className="content content-desktop">
                    <p>
                        VShots is a Full-Spectrum Production House Located in Mumbai, India.
                    </p>
                    <p>
                        Your partner for end-to-end production of cinematic films, binge worthy series, and engaging brand stories.
                    </p>
                </div>

                <div className="content content-mobile">
                    <p>
                        VShots is a Full-Spectrum Production House <br />
                        Located in Mumbai, India.
                    </p>
                    <br/>
                    <p>
                        Your partner for end-to-end production of cinematic films, binge worthy series, and engaging brand stories.
                    </p>
                </div>
                <a href="/what-we-do" className="btn" id='hero-btn'>Learn More</a>
            </section>

            {/* Trailers Section - Show trailers from dedicated Trailers section */}
            {trailers.length > 0 && (
                <section className="container" style={{ paddingTop: '10px', paddingBottom: '40px' }}>
                    <div className="scrollable-grid">
                        <div className="placeholder-grid autoscroll">
                            {loopedTrailers.map((trailer, index) => (
                                <div
                                    key={`trailer-${trailer.id}-${index}`}
                                    className="placeholder-card video-card"
                                    onClick={() => playTrailer(trailer.videoUrl)}
                                    // Hover stops scroll (via CSS), video plays always
                                    style={{ cursor: 'pointer', padding: 0, overflow: 'hidden', border: 'none' }}
                                >
                                    {/* <video
                                        src={trailer.videoUrl}
                                        muted
                                        title={trailer.title}
                                        playsInline
                                        loop
                                        // autoPlay
                                        controls 
                                        preload="metadata"
                                        style={{
                                            width: 'auto',
                                            height: '100%',
                                            objectFit: 'contain',
                                            pointerEvents: 'auto', // Enable interaction
                                        }}
                                        onClick={(e) => e.stopPropagation()} // Prevent card click when clicking video controls
                                    /> */}
                                    {console.log(`poster${index}: `, trailer.posterUrl)}
                                    {/* <img src={trailer.posterUrl} alt={`poster ${index}.png`}/> */}
                                    <video
                                        src={trailer.videoUrl}
                                        title={trailer.title}
                                        muted
                                        loop
                                        playsInline
                                        preload="auto"
                                        controls={false}
                                        // onLoadedMetadata={(e)=>{
                                        //     e.currentTarget.currentTime = 0.1
                                        // }}
                                        poster={trailer.posterUrl || trailerPosters[(index % trailerPosters.length)]}
                                        // poster={trailerPosters[(index % trailerPosters.length)]}
                                        onMouseEnter={(e) => {
                                            // let timer;
                                            const video = e.currentTarget;
                                            if (video.paused) {
                                                video.play().catch(() => {});
                                                // timer = setTimeout(()=>{
                                                //     video.play().catch(()=>{});
                                                // }, 600);
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            // let timer;
                                            const video = e.currentTarget;
                                            if (!video.paused) {
                                                // clearTimeout(timer);
                                                video.pause();
                                                video.currentTime = 0;
                                            }
                                        }}
                                        style={{
                                            width: "100%",
                                            height: '100%',
                                            objectFit: 'cover',
                                            pointerEvents: 'auto',
                                            borderRadius: "16px",
                                            overflow: "hidden"
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

             {/* Trailer Modal */}
            {showTrailer && (
                <div className="trailer-modal" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        position: 'relative',
                        width: '90%',
                        maxWidth: '1000px',
                        maxHeight: '90vh'
                    }}>
                        <button
                            onClick={closeTrailer}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'transparent',
                                border: 'none',
                                color: 'white',
                                fontSize: '24px',
                                cursor: 'pointer',
                                zIndex: 10001
                            }}
                        >
                            ×
                        </button>
                        <video
                            src={showTrailer}
                            controls
                            autoPlay
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '80vh',
                                borderRadius: '10px'
                            }}
                            >
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )}

            {/* Projects Section */}
            <section id="project" className="container">
                <h2 className="section-heading" id='project-heading'>PROJECTS</h2>
                <div className="projects-grid">
                    {homeProjects.map((project) => (
                        <div key={project.id} className="project-poster">
                            <img src={project.imageUrl} alt={project.title} />
                            <div className="project-overlay">
                                <div className="project-options">
                                    <button
                                        className="project-option-btn bts-btn"
                                        onClick={() => window.location.href = `/bts-projects#video-${project.id}`}
                                        >
                                        BTS PROJECTS
                                    </button>
                                    <button
                                        className="project-option-btn trailer-btn"
                                        onClick={() => {
                                            const trailer = trailers && project.movie ? trailers.find(t => t.movie === project.movie) : null;
                                            if (trailer) {
                                                playTrailer(trailer);
                                            } else {
                                                alert("No trailer available for this project");
                                            }
                                        }}
                                        >
                                        Trailer
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <a href="/projects" className="btn">View All</a>
            </section>

            {/* Promoters Portfolio section */}
            <section className="promoters-portfolio container">
                <h2 className="section-heading">PROMOTERS PORTFOLIO</h2>
                <div className="scrollable-grid">
                    <div className="placeholder-grid continue autoscroll">
                        {[...promoterPortfolio, ...promoterPortfolio].map(
                            (img, index) => (
                                <div className="portfolio-image" key={index}>
                                    <img title={index} src={img.low} alt={`${index}`} className='promoter-img'
                                    style={{height: "110px", width: "90px"}} />
                                </div>
                            )
                        )}
                    </div>
                </div>
            </section>

            {/* BTS Projects Section - Shows only BTS videos */}
            {btsVideos.length > 0 && (
                <section id="bts-project" className="container">
                    <h2 className="section-heading">BTS GALLERY</h2>
                    <div className="scrollable-grid bts-gallery-heading">
                        <div className="placeholder-grid autoscroll">
                            {loopedBts.map((video, index) => (
                                <div
                                key={`bts-${video.id}-${index}`}
                                className="placeholder-card video-card"
                                onClick={() => window.location.href = `/bts-projects#video-${video.projectId}`}
                                // Hover stops scroll (via CSS), video plays always
                                style={{ cursor: 'pointer', padding: 0, overflow: 'hidden', border: 'none' }}
                                >
                                    {/* <video
                                        src={video.videoUrl}
                                        title={video.title}
                                        muted
                                        playsInline
                                        loop
                                        // autoPlay
                                        preload='metadata'
                                        controls
                                        style={{
                                            width: 'auto',
                                            height: '100%',
                                            objectFit: 'contain',
                                            pointerEvents: 'auto',
                                        }}
                                        onClick={(e) => e.stopPropagation()} // Prevent card click when clicking video controls
                                    /> */}
                                    <video
                                        src={video.videoUrl}
                                        muted
                                        title={video.title}
                                        loop
                                        playsInline
                                        preload="auto"
                                        controls={false}
                                        poster={btsPosters[(index % btsPosters.length)]}
                                        onMouseEnter={(e) => {
                                            const video = e.currentTarget;
                                            if (video.paused) {
                                                video.play().catch(() => {});
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            const video = e.currentTarget;
                                            if (!video.paused) {
                                                video.pause();
                                                video.currentTime = 0;
                                            }
                                        }}
                                        style={{
                                            width: "100%",
                                            height: '100%',
                                            objectFit: 'cover',
                                            pointerEvents: 'auto',
                                            borderRadius: "14px",
                                            overflow: "hidden"
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <a href="/bts-projects" className="btn" id='bts-btn'>View All</a>
                </section>
            )}

        </>
    );
}

export default Home;

// {/* Services Section */}
// {/* <section id="what-we-do" className="container">
//     <h2 className="section-heading">What We Do</h2>
//     <div className="services-container">
//         {services.map((service) => (
//             <div key={service.id} className="service-pair">
//                 <a href={service.link} className="service-card-link">
//                     <div className="service-card">
//                         <div className="service-image-container">
//                             <img src={service.image} alt={service.title} className="service-image" />
//                         </div>
//                     </div>
//                 </a>
//                 <div className="service-name-container">
//                     <a href={service.link} className="service-name-link">
//                         <h3 className="service-name">{service.title}</h3>
//                     </a>
//                 </div>
//             </div>
//         ))}
//     </div>
//     <a href="/what-we-do" className="btn">Know More</a>
// </section> */}